<template>
    <div id="topic-mapping">
        <v-breadcrumbs :items="[
            { text: 'Kodifikasi', to: { path: '/' } },
            { text: 'Mapping' },
        ]" divider="|"></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Mapping</h3>

        <v-card class="my-4 pa-4" v-for="group in groups" v-bind:key="group.name">
            <v-card-title class="pa-0 pb-3 font-weight-bold text-subtitle-1">
                {{ group.name }}
            </v-card-title>

            <v-card-text class="pa-0 ma-0">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="4" class="pa-3" v-for="(grade, gradeIndex) in group.grades"
                            v-bind:key="gradeIndex">
                            <v-card flat outlined class="test_cursor" :to="getNavigation(grade)"
                                @click="mappingDetail(grade)">
                                <v-card-text>
                                    <v-list class="pa-0 ma-0" width="100%">
                                        <v-list-item class="pa-0 ma-0">
                                            <v-list-item-content class="pa-0 ma-0">
                                                <v-list-item-title class="text-subtitle-1 font-weight-bold black--text"
                                                    style="
                                                        word-break: break-word !important;
                                                    ">
                                                    {{ grade.display_name }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle class="text-body" style="
                                                        word-break: break-word !important;
                                                    ">
                                                    {{ grade.jenjang.nama }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-action class="pa-0 ma-0"><v-icon>mdi-chevron-right</v-icon>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-dialog v-model="showModal" transition="dialog-top-transition" width="536px" height="168px"
            @click:outside="showModal = false" scrollable>
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title class="pa-0" width="100%">
                        <v-list-item two-line style="min-height: auto">
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">
                                    Peminatan
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn plain icon small
                                    @click="dialog.value = false"><v-icon>mdi-close-circle</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-card-title>
                    <v-card-text class="pa-2" width="100%">
                        <v-container fluid>
                            <v-row>
                                <v-row>
                                    <v-col cols="6" class="py-4 px-2" v-for="(option, index) in modalOptions"
                                        :key="index">
                                        <v-card flat outlined class="test_cursor" :to="{
                                            path: '/topic-mapping/detail',
                                            query: {
                                                interest: option.interest,
                                                grade_id: selectedGrade.id,
                                            },
                                        }">
                                            <v-card-text class="py-2">
                                                <v-list class="pa-0 ma-0" width="100%">
                                                    <v-list-item class="pa-0 ma-0">
                                                        <v-list-item-avatar>
                                                            <v-img width="48px" :src="option.icon"></v-img>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content class="pa-0 ma-0">
                                                            <v-list-item-title
                                                                class="text-subtitle-1 font-weight-bold black--text"
                                                                style="word-break: break-word !important;">
                                                                {{ option.label }}
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                        <v-list-item-action
                                                            class="pa-0 ma-0"><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import ItembankService from "@/modules/itembank/services/itembank.js";
import Modal from "@/modules/global/components/plugins/Modal";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "topic-mapping",

    data: function () {
        return {
            groups: [],
            showModal: false,
            isLoading: false,
            selectedGrade: null,
        };
    },

    components: {
        "app-modal": Modal,
        "app-spinner": Spinner,
    },

    computed: {
        modalOptions() {
            if (!this.selectedGrade) return [];

            const gradeName = this.selectedGrade.display_name;
            const jenjang = this.selectedGrade.jenjang.nama;

            // SMA kelas 12
            if (jenjang === "SMA" && gradeName.includes("12")) {
                return [
                    { label: `${gradeName} IPA`, interest: "SAINTEK", icon: require("@/assets/img/topic_mapping_ipa_new.svg") },
                    { label: `${gradeName} IPS`, interest: "SOSHUM", icon: require("@/assets/img/topic_mapping_ips_new.svg") },
                    { label: "TKA", interest: "TKA", icon: require("@/assets/img/topic_mapping_tka.svg") },
                    { label: "KM", interest: "KM", icon: require("@/assets/img/topic_mapping_km.svg") },
                ];
            }

            // SMA kelas 10 & 11
            if (jenjang === "SMA" && (gradeName.includes("10") || gradeName.includes("11"))) {
                return [
                    { label: `${gradeName} IPA`, interest: "SAINTEK", icon: require("@/assets/img/topic_mapping_ipa_new.svg") },
                    { label: `${gradeName} IPS`, interest: "SOSHUM", icon: require("@/assets/img/topic_mapping_ips_new.svg") },
                    { label: "KM", interest: "KM", icon: require("@/assets/img/topic_mapping_km.svg") },
                ];
            }

            // SMP kelas 9 & SD kelas 6
            if ((jenjang === "SMP" && gradeName.includes("9")) || (jenjang === "SD" && gradeName.includes("6"))) {
                return [
                    { label: "K13", interest: "DEFAULT", icon: require("@/assets/img/topic_mapping_k13.svg") },
                    { label: "TKA", interest: "TKA", icon: require("@/assets/img/topic_mapping_tka.svg") },
                    { label: "KM", interest: "KM", icon: require("@/assets/img/topic_mapping_km.svg") },
                ];
            }

            if ((jenjang === "SMP" && gradeName.includes("8")) || (jenjang === "SMP" && gradeName.includes("7")) || (jenjang === "SD" && gradeName.includes("4")) || (jenjang === "SD" && gradeName.includes("5"))) {
                return [
                    { label: "K13", interest: "DEFAULT", icon: require("@/assets/img/topic_mapping_k13.svg") },
                    { label: "KM", interest: "KM", icon: require("@/assets/img/topic_mapping_km.svg") },
                ];
            }


            return [];
        }
    },


    methods: {
        getPicture: function (grade) {
            if (grade.jenjang.nama === "SD")
                return "@/static/assets/images/grade_sd.png";
            else if (grade.jenjang.nama === "SMP")
                return "@/static/assets/images/grade_smp.png";
            else if (grade.jenjang.nama === "SMA")
                return "@/static/assets/images/grade_sma.png";

            return "@/static/assets/images/grade_sma.png";
        },

        bgColor: function (grade) {
            if (grade.jenjang.nama === "SD") return "bg-red";
            else if (grade.jenjang.nama === "SMP") return "bg-blue";
            else if (grade.jenjang.nama === "SMA") return "bg-grey";

            return "bg-grey";
        },

        mappingDetail(grade) {
            this.selectedGrade = grade;
            const jenjang = grade.jenjang.nama;
            const display = grade.display_name;

            if (
                (jenjang === "SMA" && (display.includes("10") || display.includes("11") || display.includes("12"))) ||
                (jenjang === "SMP" && display.includes("7")) || (jenjang === "SMP" && display.includes("8")) || (jenjang === "SMP" && display.includes("9")) ||
                (jenjang === "SD" && display.includes("4")) || (jenjang === "SD" && display.includes("5")) || (jenjang === "SD" && display.includes("6"))
            ) {
                this.showModal = true;
            }
        },

        getNavigation(grade) {
            const jenjang = grade.jenjang.nama;
            const display = grade.display_name;

            // If it should open modal → no direct navigation
            if (
                (jenjang === "SMA" && (display.includes("10") || display.includes("11") || display.includes("12"))) ||
                (jenjang === "SMP" && display.includes("7")) || (jenjang === "SMP" && display.includes("8")) || (jenjang === "SMP" && display.includes("9")) ||
                (jenjang === "SD" && display.includes("4")) || (jenjang === "SD" && display.includes("5")) || (jenjang === "SD" && display.includes("6"))
            ) {
                return false; // disable router-link
            }

            // Otherwise → navigate directly
            return {
                path: '/topic-mapping/detail',
                query: {
                    interest: 'DEFAULT',
                    grade_id: grade.id,
                },
            };
        }
    },

    mounted: function () {
        var context = this;
        this.isLoading = true;
        ItembankService.getListOfTopicGrade(function (response) {
            if (response.success) {
                var groups = [];
                response.data.forEach(function (data) {
                    var groupName = data.jenjang.nama;
                    var index = groups.findIndex(function (group) {
                        return group.name === groupName;
                    });

                    if (index < 0) {
                        var group = {
                            name: groupName,
                            grades: [data],
                        };

                        groups.push(group);
                    } else {
                        groups[index].grades.push(data);
                    }
                });

                context.groups = groups;
                context.isLoading = false;
                context.$ls.set("grades", response.data);
            }
        });
    },
};
</script>



// WEBPACK FOOTER //
// TopicMapping.vue?5b123df8